export default __webpack_public_path__ + "static/media/picto_sourcingRH.8adce990.svg";